export interface ActivityEvent {
  id: string;
  type: 'ordner_update' | 'budget_update' | 'register_generated' | 'budget_calculated';
  action: string;
  target: string;
  timestamp: string;
  details?: any;
}

export const addActivity = async (memberstack: any, event: Omit<ActivityEvent, 'id' | 'timestamp'>) => {
  if (!memberstack) return;

  try {
    // Get current activities
    const response = await memberstack.getMemberJSON();
    const currentData = response.data || {};
    const activities: ActivityEvent[] = currentData.activities || [];

    // Create new activity
    const newActivity: ActivityEvent = {
      id: Date.now().toString(),
      timestamp: new Date().toISOString(),
      ...event
    };

    // Add to beginning of array and keep only last 10
    const updatedActivities = [newActivity, ...activities].slice(0, 10);

    // Save back to Memberstack
    await memberstack.updateMemberJSON({ 
      json: { 
        ...currentData,
        activities: updatedActivities 
      } 
    });

    console.log('Activity added:', newActivity);
  } catch (error) {
    console.error('Failed to add activity:', error);
  }
};

export const getActivities = async (memberstack: any): Promise<ActivityEvent[]> => {
  if (!memberstack) return [];

  try {
    const response = await memberstack.getMemberJSON();
    const currentData = response.data || {};
    return currentData.activities || [];
  } catch (error) {
    console.error('Failed to get activities:', error);
    return [];
  }
};

export const formatActivityTime = (timestamp: string, t?: (key: string) => string): string => {
  const now = new Date();
  const activityTime = new Date(timestamp);
  const diffInMinutes = Math.floor((now.getTime() - activityTime.getTime()) / (1000 * 60));

  if (!t) {
    // Fallback to German if no translation function provided
    if (diffInMinutes < 1) return 'gerade eben';
    if (diffInMinutes < 60) return `vor ${diffInMinutes} Min`;
    
    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) return `vor ${diffInHours} Std`;
    
    const diffInDays = Math.floor(diffInHours / 24);
    if (diffInDays < 7) return `vor ${diffInDays} Tag${diffInDays > 1 ? 'en' : ''}`;
    
    return activityTime.toLocaleDateString('de-CH');
  }

  if (diffInMinutes < 1) return t('activity.justNow');
  if (diffInMinutes < 60) return t('activity.minutesAgo').replace('{count}', diffInMinutes.toString());
  
  const diffInHours = Math.floor(diffInMinutes / 60);
  if (diffInHours < 24) return t('activity.hoursAgo').replace('{count}', diffInHours.toString());
  
  const diffInDays = Math.floor(diffInHours / 24);
  if (diffInDays < 7) return t('activity.daysAgo').replace('{count}', diffInDays.toString());
  
  return activityTime.toLocaleDateString('de-CH');
};
